export async function fetchServicesPorts() {
  const r = await fetch("/api/services/ports", { cache: "no-store" });
  if (!r.ok) throw new Error(`services/ports HTTP ${r.status}`);
  return r.json();
}

export async function fetchServicesDocker() {
  const r = await fetch("/api/services/docker", { cache: "no-store" });
  if (!r.ok) throw new Error(`services/docker HTTP ${r.status}`);
  return r.json();
}

export async function fetchServicesSystemd() {
  const r = await fetch("/api/services/systemd", { cache: "no-store" });
  if (!r.ok) throw new Error(`services/systemd HTTP ${r.status}`);
  return r.json();
}
